import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as Common from 'common/components';
import { valueFromEvent } from 'lib/util';
import { isLockedFile } from 'lib/pdfs/autosur/valeResguardoAutosur';

class AssetsFormFilesRow extends PureComponent {
  static propTypes = {
    file: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    handleFileChange: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleRemove = (e) => {
    e.preventDefault();
    this.props.handleRemove(this.props.id);
  };

  state = { preview: null };

  render = () => {
    return (
      <tr>
        <td className="text-center align-middle">
          <Common.File file={this.props.file} />
        </td>
        <td className="align-middle">{this.props.file.name}</td>
        <td className="align-middle text-center">{this.props.t('files.uploaded')}</td>
        <td className="align-middle text-center">
          <Common.Form.Checkbox
            className="icheckbox_flat-blue"
            name={'default'}
            onChange={(e) => {
              this.props.handleFileChange(this.props.id, valueFromEvent(e));
            }}
            checked={this.props.file.default}
          />
        </td>
        <td className="align-middle">
          {/* A signed voucher cannot be removed: the back keeps it anyway. */}
          {isLockedFile(this.props.file) ? (
            <span className="text-muted small">
              <i className="fa fa-lock mr-1" />
              {this.props.t('files.locked')}
            </span>
          ) : (
            <button className="btn btn-danger btn-sm" onClick={this.handleRemove}>
              {this.props.t('actions.delete')}
            </button>
          )}
        </td>
      </tr>
    );
  };
}

export default translate()(AssetsFormFilesRow);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormFilesRow.js